export const CHECKOUT_URL = 'https://atleta-corporativo.impultienda.ar/checkout'

export const ELITE_CHECKOUT_URL =
  'https://atleta-corporativo-elite.impultienda.ar/checkout'

export const LAUNCH_LIMIT = '100 plazas'

export const painList = [
  'Las 15:00 donde el cerebro se apaga y ni el café ayuda',
  'Llegar a casa y no tener energía para nada que no sea el sillón',
  'El domingo con ansiedad anticipatoria pensando en el lunes',
  'Cinco cafés por día que ya no te despiertan, solo te dan taquicardia',
  'Dolores de cuello y espalda que se volvieron "normales"',
  'Foco que dura 40 minutos y después saltás de tab en tab sin producir',
  'Reuniones que drenan más energía de la que tenés disponible',
  'Fin de semana que termina sin haberte recuperado realmente',
]

export const hardCosts = [
  {
    icon: 'clock',
    stat: '400 horas',
    label:
      'de productividad perdidas por año: 2 horas menos por jornada por el crash de la tarde.',
  },
  {
    icon: 'coffee',
    stat: '5 cafés',
    label:
      'por día que ya no despiertan: taquicardia, ansiedad y peor sueño crónico.',
  },
  {
    icon: 'loop',
    stat: 'El mismo lunes',
    label: 'otra vez. Y el que viene. Y el año que viene.',
  },
]

export const tomos = [
  {
    number: '01',
    title: 'El Despertar del Atleta Corporativo',
    window: '9:00 a 12:00',
    description:
      'Cortisol, luz solar, hidratación celular y el bloque de foco más poderoso del día.',
  },
  {
    number: '02',
    title: 'El Hackeo del Mediodía',
    window: '12:00 a 14:00',
    description:
      'Comandos de delivery inteligente, digestión sin coma alimentario y recarga energética estratégica.',
  },
  {
    number: '03',
    title: 'La Hora Más Peligrosa',
    window: '14:00 a 17:00',
    description:
      'Cómo sobrevivir y rendir en las horas donde todos bajan el rendimiento.',
  },
  {
    number: '04',
    title: 'Tu Entorno te está Programando',
    window: 'Todo el día',
    description:
      'Temperatura, luz, ruido, biofilia y entorno digital sin distracciones.',
  },
  {
    number: '05',
    title: 'El Capítulo más Ignorado del Rendimiento',
    window: '16:00 a 17:00',
    description:
      'Shutdown Ritual, desconexión sin culpa y transición al modo personal.',
  },
  {
    number: '06',
    title: 'El Último Hack del Sistema',
    window: '17:00 a 9:00',
    description:
      'Arquitectura del sueño, protocolo pre-sueño y despertar estratégico.',
  },
]

export const tomoIncludes = [
  'Protocolo listo para implementar desde el día 1',
  'Protocolo estructurado, no teoría suelta',
  'Adaptado al ritmo laboral argentino (9 a 17)',
  'Checklists, worksheets y timelines accionables',
  'Casos reales de oficina y home office argentinos',
  'Versión imprimible y versión digital optimizada',
  'Sin gimnasio, sin dietas extremas, sin apps complicadas',
]

export const bonos = [
  {
    number: '01',
    icon: 'rocket',
    title: 'Kit de Implementación Express 7 Días',
    description: 'Un hábito por día, sin fricción.',
    price: '$7.000',
  },
  {
    number: '02',
    icon: 'utensils',
    title: 'Comandos de Delivery Inteligente',
    price: '$5.000',
  },
  {
    number: '03',
    icon: 'cards',
    title: 'Tarjetas de Reseteo en Escritorio',
    price: '$4.500',
  },
  {
    number: '04',
    icon: 'calendar',
    title: 'Planner de Energía 9 a 17',
    price: '$6.000',
  },
  {
    number: '05',
    icon: 'message',
    title: 'Scripts de Límites y Desconexión',
    price: '$5.000',
  },
  {
    number: '06',
    icon: 'home',
    title: 'Checklist de Setup Express Home & Oficina',
    price: '$4.500',
  },
]

export const BONOS_TOTAL = '$32.000'

export const testimonials = [
  {
    initials: 'MG',
    name: 'Martín G.',
    location: 'Buenos Aires',
    role: 'Gerente de Operaciones',
    quote:
      'Llegaba a casa destruido. Ahora a las 17:00 todavía tengo energía para salir a caminar con mis hijos. El Tomo 3 me cambió la tarde.',
  },
  {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Rosario',
    role: 'Directora Comercial',
    quote:
      'El Cocktail de Enfoque del Tomo 1 reemplazó mi tercer café. Tres semanas después, la diferencia en el foco de la mañana es brutal.',
  },
  {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Córdoba',
    role: 'Contador Senior',
    quote:
      'El Protocolo de Cierre del Tomo 5 fue lo que necesitaba. Cierro la laptop a las 17:00 sin culpa y duermo como no dormía hace 10 años.',
  },
]

export const comparisonRows = [
  {
    capability: 'Jornada 9 a 17 optimizada — 6 Tomos + 6 Bonos',
    standard: true,
    elite: 'Incluido',
  },
  {
    capability: 'After office y asados corporativos',
    standard: false,
    elite: 'Protocolo de Alcohol Estratégico',
  },
  {
    capability: 'Semanas de crisis con sueño limitado',
    standard: false,
    elite: 'Sprint de 72 Horas y nap táctico',
  },
  {
    capability: 'Negociaciones y presentaciones críticas',
    standard: false,
    elite: 'Dominancia biológica + Power Posing',
  },
  {
    capability: 'Foco extremo y recuperación post-crisis',
    standard: false,
    elite: 'Stack Táctico + Reset Post-Crisis',
  },
]

export const plans = [
  {
    id: 'standard',
    name: 'Programa Atleta Corporativo',
    subtitle: '6 Tomos + 6 Bonos',
    idealFor:
      'El profesional que quiere optimizar su jornada completa de 9 a 17',
    originalPrice: '$75.000',
    price: '$24.990',
    checkoutUrl: 'https://atleta-corporativo.impultienda.ar/checkout',
    cta: 'Quiero mi Programa',
    featured: false,
  },
  {
    id: 'elite',
    name: 'Atleta Corporativo Élite',
    subtitle: '6 Tomos + 6 Bonos + Intervención Crítica',
    idealFor:
      'El profesional que también necesita rendir bajo presión extrema, negociaciones críticas y situaciones de alta exigencia',
    originalPrice: '$105.000',
    price: '$34.990',
    checkoutUrl: 'https://atleta-corporativo-elite.impultienda.ar/checkout',
    cta: 'Quiero mi Programa Élite',
    featured: true,
  },
]

export const faqs = [
  {
    question: '¿Necesito ir al gimnasio o hacer dieta?',
    answer:
      'No. El sistema está diseñado para aplicarse dentro de tu jornada laboral, en tu escritorio, con lo que ya tenés. Sin rutinas de ejercicio obligatorias, sin dietas restrictivas. Si ya hacés ejercicio, el sistema potencia eso. Si no hacés, el sistema funciona igual.',
  },
  {
    question: '¿Cuánto tiempo requiere por día?',
    answer:
      'Los protocolos de reseteo duran 60 segundos. La planificación diaria con el Planner son 6 minutos. Las intervenciones más largas (el Shutdown Ritual, el protocolo pre-sueño) son de 15 minutos. Todo está diseñado para integrarse en lo que ya hacés, no para agregar una hora más al día.',
  },
  {
    question: '¿Está adaptado para Argentina?',
    answer:
      '100%. Hablamos de PedidosYa, Rappi y Uber Eats. De asados corporativos. De after offices. De mate. De la cultura laboral argentina de 9 a 17. De home office con familiares. No es material traducido del inglés: es un sistema creado desde Argentina para Argentina.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Inmediatamente después de la compra recibís un mail con el link de descarga de todos los PDFs. Acceso en menos de 5 minutos. No hay envío físico. Todo digital, todo descargable, todo tuyo para siempre.',
  },
  {
    question: '¿Tiene garantía real?',
    answer:
      'Sí. 7 días de garantía total. Si abrís los tomos y no es lo que esperabas, escribís a soporte y te devolvemos el 100% sin preguntas. Sin formularios complicados. Sin drama. La tasa de devolución es menor al 1% porque el sistema funciona.',
  },
  {
    question: '¿Qué lo diferencia de los libros de productividad que ya leí?',
    answer:
      'Los libros de productividad te dicen qué hacer. Este sistema te dice exactamente cómo hacerlo, a qué hora, con qué herramienta y en qué orden, dentro de una jornada laboral argentina real. No es teoría: son protocolos accionables, diseñados para alguien que no tiene tiempo de leer otro libro.',
  },
]
